
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

import { iconNames } from '@/utils/constant'
import GuideService from '@/components/GuideService'

export default {
name: 'Home',
components: {
Flexbox,
FlexboxItem,
Toast,
Loading,
GuideService
},
data() {
return {
diseaseCategory: [],
position: 'default',
showPositionValue: false,
tips: '',
showLoading: false,
content: '',
iconNames: iconNames
}
},
methods:{
alert (tips) {
this.position = 'bottom'; 
this.showPositionValue = true;
this.tips = tips;
},
loading(show, content) {
this.showLoading = show;
this.content = content;
},
chat(cnName, enName, id) {
this.$router.push({path: '/zhongshan/chat/zhongshan', query: {cnName: cnName, enName: enName, id: id}});
},
initPage() {
this.$route.meta.title = '中山眼科智能问答';
this.loading(true,'');
let url = 'department/all/zhongshan';
this.$http.get(url, null,(res) => {
this.diseaseCategory = res.data;
this.loading(false,'');
}, (error) => {
console.log(error);
this.loading(false,'');
this.alert('连接不上服务器，请检查网络')
});
}
},
mounted() {
this.initPage();
}
}



// WEBPACK FOOTER //
// ./src/views/zhongshan/Home.vue